import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ConfigProvider } from "@/context/ConfigContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Status from "@/pages/Status";
import DomainSearch from "@/pages/DomainSearch";
import MyDomains from "@/pages/MyDomains";
import DNSManager from "@/pages/DNSManager";
import WhoisUpdate from "@/pages/WhoisUpdate";
import SSL from "@/pages/SSL";
import Whois from "@/pages/Whois";
import BuyDomain from "@/pages/BuyDomain";
import Purchases from "@/pages/Purchases";

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/status" replace />} />
              <Route path="/status" element={<Status />} />
              <Route path="/credentials" element={<Navigate to="/status" replace />} />
              <Route path="/search" element={<DomainSearch />} />
              <Route path="/buy" element={<BuyDomain />} />
              <Route path="/domains" element={<MyDomains />} />
              <Route path="/dns" element={<DNSManager />} />
              <Route path="/whois-update" element={<WhoisUpdate />} />
              <Route path="/ssl" element={<SSL />} />
              <Route path="/whois" element={<Whois />} />
              <Route path="/history" element={<Purchases />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
